import { create } from 'zustand';

interface WelcomePageModal {
  isOpen: boolean;
  pageContentsType: TWelcomePageType;
  openModal: (type: TWelcomePageType) => void;
  closeModal: () => void;
}

const useWelcomePageModalStore = create<WelcomePageModal>(set => ({
  isOpen: false,
  pageContentsType: '',
  openModal: type => {
    return set({ isOpen: true, pageContentsType: type });
  },
  closeModal: () => set({ isOpen: false }),
}));

export default useWelcomePageModalStore;
